export const MARK_WALKTHROUGH_EVENT = {
  started: 'MARK Walkthrough Started',
  viewed: 'MARK Walkthrough Viewed',
  dismissed: 'MARK Walkthrough Dismissed',
  pathSelected: 'MARK Walkthrough Path Selected',
  completed: 'MARK Walkthrough Completed',
} as const satisfies Record<string, string>;

export type MarkWalkthroughEventName =
  (typeof MARK_WALKTHROUGH_EVENT)[keyof typeof MARK_WALKTHROUGH_EVENT];

export type MarkWalkthroughSection =
  | 'introPopup'
  | 'walkthroughModal'
  | 'hintTour';

export type MarkWalkthroughEntryPoint = 'firstVisit' | 'introPopup';

export type MarkWalkthroughPath = 'sendExampleMessage' | 'startHintTour';

export type MarkWalkthroughDismissMethod =
  | 'maybeLater'
  | 'escape'
  | 'clickOutside'
  | 'closeButton'
  | 'skip';

export type MarkWalkthroughCompletionType =
  | 'hintsFinished'
  | 'essentialExampleSent';
